// Tiny haptics adapter. Android Chrome vibrates; iOS Safari silently no-ops
// (navigator.vibrate is absent there) — that's the accepted platform reality.
export function vibrate(pattern: number | number[]): void {
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* not available — fine */
  }
}
